<template>
    <div class="section-box">
        <el-row class="row-bg">
            <el-col :span="24" style="text-align: right;">
                <el-button size="medium" type="primary" @click="handleSearch">查询</el-button>
                <el-button size="medium" type="success" @click="handleReset">重置</el-button>
                <el-button size="medium" type="primary" icon="el-icon-plus" @click="checkDetail()">新增</el-button>
            </el-col>
        </el-row>

        <!-- 列表 -->
        <el-table
            :stripe="true"
            :data="tableData"
            style="width: 100%"
            height="666"
            border
            v-loading="listLoading" 
            >
            <!-- eslint-disable  -->
            <el-table-column label="编号">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.SerialNumber" placeholder="输入关键字搜索" @blur="GetCouponsList()"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.pkid || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="大咖面对面名称" >
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.name" placeholder="输入关键字搜索"  @blur="GetCouponsList()"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.name || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="发布状态" >
                <el-table-column show-overflow-tooltip  width="180">
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model="form.status" placeholder="请选择发布状态"  @change="GetCouponsList()">
                            <el-option value="1" label="已发布"></el-option>
                            <el-option value="0" label="未发布"></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span v-if="scope.row.isShow == 0">未发布</span>
                        <span v-if="scope.row.isShow == 1">已发布</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="创建时间">
                <el-table-column show-overflow-tooltip width="250">
                    <template slot="header" slot-scope="scope">
                        <el-date-picker size="mini" v-model="form.EffectivityTime" type="daterange" format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd" range-separator="—" start-placeholder="开始日期"
                            end-placeholder="结束日期" style="width: 100%" @change="handleSearch()"></el-date-picker>
                    </template>
                    <template slot-scope="scope">
                        <span>{{ scope.row.createTime || "--" }}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" plain @click="checkDetail(scope.row)">查看</el-button>
                    <el-button type="primary" size="mini"  v-if="scope.row.isShow == 0" @click="isPublish(scope.row.isShow,scope.row.pkid)">发布</el-button>
                    <el-button type="primary" size="mini"  v-if="scope.row.isShow == 1" @click="isPublish(scope.row.isShow,scope.row.pkid)">取消发布</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;" v-show="tableData.length">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="form.PageNo"
                    :page-sizes="[10, 20, 50, 100, 200]"
                    :page-size="form.PageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
// DOTO：静态展示数据 对接的时候可以删掉
import { PERIOD } from '@/config/const/common.js'
// End
import { 
  getStorageToken,
} from '@/utils/store'
import {
    couponsList,
} from "@/service/coupons";
import {
        masterList,
        publishApi,
    } from "@/service/masterApi";
  export default {
    data() {
        return {
            PERIOD,
            listLoading: false,
            form: {
                PageNo: 1,
                PageSize: 10,

                name: '',               //名称
                SerialNumber:'',
                status:'',
                EffectivityTime: [],    //时间
            },
            searchData:{},
            oraginForm:{},
            total: 0,                       //总条数
            tableData:[],
        }
    },
    activated(){
        this.handleSearch()
    },
    created() {
        this.oraginForm = JSON.parse(JSON.stringify(this.form))
        this.tableData = [];
    },
    computed: {
    },
    mounted() {
    },
    methods: {
        isPublish(type,id){
            
            var params = {
                isShow : type==0?1:0,
                pkid:id
            }
            publishApi(params).then((r)=>{
                if(r.Result != 1){
                    this.$message.error('请求失败,请重试')
                }
                if(type == 0){
                    this.$message.success('已取消发布')
                }
                if(type == 1){
                    this.$message.success('发布成功')
                }
                this.GetCouponsList()
            })
        },
        checkDetail(row){
            if (row) {
          this.$router.push(`/market/videoDetail?pkid=${row.pkid}`);
        } else {
          this.$router.push(`/market/videoDetail?pkid=-1`);
        }
        },
        //渲染列表
        handleSearch() {
            this.searchData = Object.assign({}, this.form)
            this.handleCurrentChange(1)
        },
        handleCurrentChange(val) {
            if (this.listLoading) return
            this.form.PageNo = val
            this.searchData.PageNo = val
            this.GetCouponsList()
        },
        //翻页
        handleSizeChange(val) {
        if (this.listLoading) return
            this.form.PageNo = 1
            this.form.PageSize = val
            this.searchData.PageNo = 1
            this.searchData.PageSize = val
            this.GetCouponsList()
        },
        // TODO：修改接口名 form参数 table展示数据 -> 平台、发单方角色select
        async GetCouponsList(){
            const _this = this
            this.listLoading = true
            var data = {
                rational:true,
            }
            if (_this.form.EffectivityTime instanceof Array &&_this.form.EffectivityTime.length > 0) {
                    data.createStartTime = _this.form.EffectivityTime[0] + " 00:00:00";
                    data.createEndTime = _this.form.EffectivityTime[1] + " 23:59:59";
                    } 
                    else {
                    if (data.createStartTime) delete data.createStartTime;
                    if (data.createEndTime) delete data.createEndTime;
                    }
             if(this.form.status) data.isShow = this.form.status
             if(this.form.name) data.name = this.form.name
             if(this.form.SerialNumber) data.pkid = this.form.SerialNumber

            let res = await masterList(data)
            this.listLoading = false
            if(res.Result != 1) {
                return this.$message.error('获取失败请联系开发人员')
            }
            this.tableData = res.Data.datas
            this.total = res.Data.total
        },
        handleReset() {
            this.form = JSON.parse(JSON.stringify(this.oraginForm))
            this.handleSearch()
        },
    }
  }
</script>

<style lang="scss">
    .el-row {
        margin-bottom: 20px;
        &:last-child {
        margin-bottom: 0;
        }
    }
    .row-bg {
        padding: 10px 14px;
        background-color: #f9fafc;
    }
</style>